type AccordionItem = {
  id: string;
  question: string;
  answer: string;
};

type AccordionProps = {
  items: AccordionItem[];
};

export function Accordion({ items }: AccordionProps) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <details
          key={item.id}
          id={item.id}
          className="surface-card group px-5 py-4 [&_summary::-webkit-details-marker]:hidden"
          open
        >
          <summary className="flex min-h-11 cursor-pointer items-center justify-between gap-4 text-lg font-semibold">
            {item.question}
            <span
              aria-hidden="true"
              className="text-2xl text-brand-700 transition group-open:rotate-45"
            >
              +
            </span>
          </summary>
          <p className="mt-3 text-ink-soft">{item.answer}</p>
        </details>
      ))}
    </div>
  );
}
